import { Assignment, Delete, Edit } from '@material-ui/icons'
import React from 'react'
import { Action, ActionHandlers } from '../components/ActionsColumn/interfaces/ActionsColumn'
import Authority from '../../../../util/Authority'

export const getActions = (status: string, handlers: ActionHandlers, itemCompany: number): Action[] => {
  return [
    {
      showAction: Boolean(status),
      type: 'show',
      tooltipLabel: 'appointment.calendar.transfer.scheduleDialogTitle',
      color: 'info',
      icon: <Assignment />,
      onClick: handlers.show
    },
    {
      showAction: ((status === "CREATED" || status === "APPROVED") && Authority.getAuthorizedCompanyId() === itemCompany),
      type: 'edit',
      tooltipLabel: 'appointment.service.edit',
      color: 'success',
      icon: <Edit />,
      onClick: handlers.edit
    },
    {
      showAction: ((status === "CREATED") && Authority.isFinancierUser()),
      type: 'delete',
      tooltipLabel: 'appointment.service.delete',
      color: 'danger',
      icon: <Delete />,
      onClick: handlers.delete
    },
  ]

}
